export default __webpack_public_path__ + "static/media/prev.d8b37e01.svg";